import { useQuery } from 'react-query';
import { TiposPerdidosService } from '../service/tipos-perdidos-service';

const perdidos = new TiposPerdidosService();

export const useTiposPerdidos = () => {
  const { data: tiposPerdidos, isLoading: loadingTiposPerdidos } = useQuery({
    queryKey: 'tiposPerdidos',
    queryFn: perdidos.getTiposPerdidos,
    refetchOnWindowFocus: false
  });

  return { tiposPerdidos, loadingTiposPerdidos };
};
